export default __webpack_public_path__ + "static/media/val.e6104c70.gif";